'use strict';exports.__esModule = true;var formatAddress = function formatAddress(address, isCountryName) {
  var house = !!address.house_number ? ' ' + address.house_number : '';
  var country = isCountryName && !!address.country_name ? ', ' + address.country_name : '';

  return '' + address.street_name + house + (address.street_name || house ? ', ' : '') + address.city_name + country;
};exports.default =

formatAddress;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatAddress.js
// module id = 236
// module chunks = 0